<template>
  <div class="q-pt-xs">
    <MappedItemDetailsRow v-if="isVehicle" data-t="vin" label="VIN">
      <ZubieChip color="transparent" dense flat :outline="false" :search-terms="searchTerms">
        {{ asset.vin || '--' }}
      </ZubieChip>
    </MappedItemDetailsRow>

    <MappedItemDetailsRow
      v-if="asset.connectedDevices.length"
      class="q-mt-xs"
      label="Device #"
      perpendicular-alignment-class="items-start"
    >
      <DeviceChip
        v-for="(device, index) in asset.connectedDevices"
        :key="device.key"
        :class="{ 'item-first': index === 0 && asset.connectedDevices.length > 1 }"
        dense
        :device="device"
        :search-terms="searchTerms"
      />
    </MappedItemDetailsRow>

    <MappedItemDetailsRow v-if="!isRental && isVehicle" class="q-mt-xs" data-t="driver" label="Driver">
      <DriverChip data-t="driverHighlight" dense :driver="asset.driver" :search-terms="searchTerms" />
    </MappedItemDetailsRow>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DeviceChip from 'components/chips/DeviceChip.vue';
import DriverChip from 'components/chips/DriverChip.vue';
import ZubieChip from 'components/chips/ZubieChip.vue';
import MappedItemDetailsRow from 'components/vehicles-list/MappedItemDetailsRow.vue';
import Asset from 'src/models/Asset';
import Vehicle from 'src/models/Vehicle';

export default {
  name: 'MappedItemIdsAndDriver',
  components: {
    DeviceChip,
    MappedItemDetailsRow,
    DriverChip,
    ZubieChip,
  },
  props: {
    asset: {
      required: true,
      type: [Vehicle, Asset],
    },
    searchTerms: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters('session', ['isRental']),
    isVehicle() {
      return this.asset instanceof Vehicle;
    },
  },
};
</script>

<style scoped>
.item-first {
  margin-bottom: 4px !important; /* putting q-mb-xs here causes a double margin because the class is applied to DeviceChip and ZubieChip */
}
</style>
